export const site = {
  name: "Usubi Lab.",
  email: "hello@usubilab.com",
  headline: ["Independent", "software lab."],
  introduction: ["One person. Small tools.", "Built for everyday use."]
} as const;

export const products = [
  {
    id: "rehear",
    name: "Rehear",
    icon: "/assets/products/rehear.webp",
    platform: "iPhone & iPad",
    description: "Learn languages with your own audio and podcasts.",
    href: "https://apps.apple.com/app/id6773232649",
    action: "View on the App Store"
  },
  {
    id: "dockhandy",
    name: "Dockhandy",
    icon: "/assets/products/dockhandy.webp",
    platform: "macOS",
    description: "Check your external drives before closing your Mac.",
    href: "https://dockhandy.app",
    action: "Visit Dockhandy"
  }
] as const;

export const media = [
  {
    id: "gogaku-chudoku",
    name: "語学中毒。",
    platform: "Web magazine in Japanese",
    description:
      "Gogaku Chudoku is a Japanese web magazine on language learning: textbooks, podcasts, and listening practice, edited by Usubi Lab.",
    href: "https://magazine.rehearapp.com/",
    action: "Visit magazine"
  }
] as const;
